import { render, staticRenderFns } from "./tableAct.vue?vue&type=template&id=642f7ad4&scoped=true"
import script from "./tableAct.vue?vue&type=script&lang=js"
export * from "./tableAct.vue?vue&type=script&lang=js"
import style0 from "./tableAct.vue?vue&type=style&index=0&id=642f7ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642f7ad4",
  null
  
)

export default component.exports